import { cargaAssetsDisposicion } from './assetsDisposicion';
import { cargaAssetsBotones } from './assetsBotones';
import { cargaAssetsCartas } from './assetsCartas';
import { cargaAssetsCartelesMano } from './assetsCartelesMano';
import { cargaAssetsDisplays } from './assetsDisplays';
import { cargaAssetsFichasAlfombra } from './assetsFichasAlfombra';
import { cargaAssetsFichasEleccion } from './assetsFichasEleccion';
import { cargaAssetsFlechaMano } from './assetsFlechaMano';
import { cargaAssetsFondo } from './assetsFondo';
import { cargaAssetsMensajesPanel } from './assetsMensajesPanel';
import { cargaAssetsNumerosDisplay } from './assetsNumerosDisplay';

/**
 * Carga todos los assets del juego del BlackJack
 * @param {*} scene
 */
export function cargaAssetsPrincipal(scene) {
  cargaAssetsDisposicion(scene);
  cargaAssetsBotones(scene);
  cargaAssetsCartas(scene);
  cargaAssetsCartelesMano(scene);
  cargaAssetsDisplays(scene);
  cargaAssetsFichasAlfombra(scene);
  cargaAssetsFichasEleccion(scene);
  cargaAssetsFlechaMano(scene);
  cargaAssetsFondo(scene);
  cargaAssetsMensajesPanel(scene);
  cargaAssetsNumerosDisplay(scene);
}
